const firebaseConfig = {
    apiKey: "AIzaSyCOVRAXTsyeLbxyOgJseNI_pwq71JpxRTo",
    authDomain: "goodmakeup-5991d.firebaseapp.com",
    projectId: "goodmakeup-5991d",
    storageBucket: "goodmakeup-5991d.appspot.com",
    messagingSenderId: "233751319001",
    appId: "1:233751319001:web:7f34057dd8ddb2aeb3c9c8"
};
export default firebaseConfig;